// 用户模块
const state = {
  userId: null,
  userInfo: null
}

const mutations = {
  SET_USER_ID(state, userId) {
    state.userId = userId
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
  }
}

const actions = {
  setUserId({ commit }, userId) {
    commit('SET_USER_ID', userId)
  },
  setUserInfo({ commit }, userInfo) {
    commit('SET_USER_INFO', userInfo)
  }
}

const getters = {
  userId: state => state.userId,
  userInfo: state => state.userInfo
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

